<template>
	<div>
		<b-modal v-model="modal" no-close-on-backdrop>
			<template #modal-header>
				<h5>{{ title }}</h5></template
			>

			<b-row>
				<b-col>
					<text-input
						ref="description"
						v-model="form.description.value"
						:form="form"
						:name="'description'"
						:alias="form.description.alias"
					/>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<text-input
						ref="code"
						v-model="form.code.value"
						:form="form"
						:name="'code'"
						:alias="form.code.alias"
					/>
				</b-col>
			</b-row>
			<b-form-checkbox
				switch
				v-model="form.status.value"
				:value="1"
				:unchecked-value="0"
			>
				<span style="cursor:pointer">{{
					form.status.text[form.status.value]
				}}</span>
			</b-form-checkbox>
			<template #modal-footer>
				<button
					class="btn btn-outline-secondary"
					role="button"
					tabindex="-1"
					@click="modal = false"
				>
					<i class="fas fa-times"></i> Cancelar
				</button>
				<button
					role="button"
					style="margin-left: 5px"
					class="btn btn-success ml-2"
					@click="store()"
				>
					<i class="fas fa-check"></i> Salvar
				</button>
			</template>
		</b-modal>
	</div>
</template>

<script>
	import Form from "../../../mixins/Form";

	export default {
		data() {
			return {
				id: null,
				title: null,
				modal: false,
				isLoading: false,
				form: new Form({
					id: {
						value: null
					},
					code: {
						value: null,
						alias: 'Codigo ',
						validate: {
							required: true
						},
					},

					description: {
						alias: "Descrição",
						validate: {
							required: true,
						},
					},


					status: {
						alias: "Status",
						default: 1,
						text: {
							1: "Este cadastro está ativo",
							0: "Este cadastro está inativo"
						}
					}
				})
			}
		},

		computed: {
			planGroup() {
				return this.$store.state.accountPlan.planGroup;
			},
		},

		methods: {
			open(id) {
				this.form.reset();
				this.$store.commit("showLoading");

				if (id != null) {
					this.$store
						.dispatch("accountPlan/getAccountPlanGroup", id)
						.then(response => {
							this.form.setValues(this.planGroup);
							this.title = 'Editar Grupo de Planos de contas'
							this.$store.commit("hideLoading");
							this.modal = true
						}).catch(error => {
							console.log(error)
						});
				}
				if (id == null) {
					this.title = 'Novo Grupo de Planos de contas'
					this.$store.commit("hideLoading");
					this.modal = true
				}
			},

			setAccountPlanGroup(account_plan_group) {
				this.form.account_plan_group_id.value = account_plan_group.id;
				this.form.account_plan_group.value = account_plan_group.description;
			},

			store() {
				if (this.form.isValid()) {

					this.$store.commit("showLoading");
					this.$store
						.dispatch("accountPlan/storeAccountPlanGroup", {
							params: this.form.getValues(), id: this.form.id.value
						})
						.then(response => {
							this.modal = false
							this.$emit('store')
							this.$store.commit("hideLoading");
						}).catch(error => {
							this.modal = false
							this.$emit('store')
							this.$store.commit("hideLoading");

						});
				}
			}
		},
	}
</script>
<style>

</style>